import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTrackGeneratedShareUrl } from '@air/analytics';
import { ShortUrl } from '@air/api';
import { ShortUrlObjectType } from '@air/api/types';
import { reportErrorToBugsnag } from '@air/utils-error';

import { getShortIdInformationKey } from '~/swr-hooks/shortUrl/useGetExistingShortIdInformation';

export const useGetShortIdForCanvas = () => {
  const queryClient = useQueryClient();
  const { trackGeneratedShareUrl } = useTrackGeneratedShareUrl();

  return useMutation({
    mutationFn: (params: { workspaceId: string; id: string }) =>
      ShortUrl.getShortIdForObject({ ...params, type: ShortUrlObjectType.canvas }),
    onSuccess: (data, params) => {
      queryClient.setQueryData(getShortIdInformationKey({ objectId: params.id, boardContext: undefined }), data);

      trackGeneratedShareUrl({
        type: 'canvas',
        id: data.id,
      });
    },
    onError: (error, params) => {
      throw reportErrorToBugsnag({
        error,
        context: 'Failed to get short id for canvas',
        metadata: { data: { params } },
      });
    },
  });
};
